import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Image, Button, Icon, Table, Modal } from "semantic-ui-react";
import { image } from "../../../../assets";
import { Company } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal, ConfirmDialog } from "../../../Shared";
import { ENV } from "../../../../utils";
import { CompanyForm } from "../CompanyForm";
import "./CompanyItem.scss";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { useLanguage } from "../../../../contexts";

const companyController = new Company();

export function CompanyItem(props) {
  const { company, onReload, permissionsByRole } = props;
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmHeader, setConfirmHeader] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [modalOpen, setModalOpen] = useState(false); // Estado para abrir/cerrar el modal
  const [contentModal, setContentModal] = useState("");
  const [rowMenu, setRowMenu] = useState(null); // { top, left, openUp } | null

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  useEffect(() => {
    if (!rowMenu) return;
    const handler = (e) => {
      if (!e.target.closest(".company-item__row-menu, .company-item__row-menu-list")) setRowMenu(null);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [rowMenu]);

  const toggleRowMenu = (e) => {
    if (rowMenu) { setRowMenu(null); return; }
    const rect = e.currentTarget.getBoundingClientRect();
    const menuHeight = 150;
    const openUp = rect.bottom + menuHeight > window.innerHeight;
    setRowMenu({
      left: rect.right - 170,
      top: openUp ? rect.top - 4 : rect.bottom + 4,
      openUp,
    });
  };

  const openUpdateCompany = () => {
    setTitleModal(`${t("update")} ${company.name}`);
    onOpenCloseModal();
  };

  const openDesactivateActivateConfim = () => {
    setIsDelete(false);
    setConfirmHeader("Activar/Desactivar");
    setConfirmMessage(
      company.active
        ? `Desactivar empresa "${company.name}"`
        : `Activar empresa "${company.name}"`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await companyController.updateCompany(accessToken, company._id, {
        active: !company.active,
      });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmHeader("Eliminar");
    setConfirmMessage(`¿Está seguro de eliminar la empresa "${company.name}"?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      const response = await companyController.deleteCompany(accessToken, company._id);
      onReload();
      onOpenCloseConfirm();
      // No se pudo avisar a la otra app Sustemia: el master tiene que saberlo.
      if (response?.integrationWarning) {
        setContentModal(response.integrationWarning);
        setModalOpen(true);
      }
    } catch (error) {
      console.error(error);
      setContentModal(error.msg);
      setModalOpen(true);
      onOpenCloseConfirm();
    }
  };
  // Manejador de cierre del modal
  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Table.Row key={company._id}>
        <Table.Cell data-label={t("company_name")}>{company.name ? company.name : ""}</Table.Cell>
         <Table.Cell data-label={t("cuit")}>{company.cuit}</Table.Cell>
          <Table.Cell data-label={t("phone")}>{company.phone}</Table.Cell>
        <Table.Cell data-label={t("email")}>{company.email}</Table.Cell>
        <Table.Cell textAlign="center" data-label="" className="companies-table__actions" onClick={(e) => e.stopPropagation()}>
          <div className="company-item__row-menu">
            <button type="button" className="company-item__row-menu-btn" onClick={toggleRowMenu} aria-label={t("actions")}>
              <Icon name="ellipsis vertical" />
            </button>
          </div>
          {rowMenu && ReactDOM.createPortal(
            <div
              className="company-item__row-menu-list"
              style={{
                position: "fixed",
                top: rowMenu.top,
                left: rowMenu.left,
                transform: rowMenu.openUp ? "translateY(-100%)" : "none",
              }}
            >
              {(isMaster(role) || isAdmin(role) ||
                hasPermission(permissionsByRole, role._id, "companies", "edit")) && (
                <button onClick={() => { openUpdateCompany(); setRowMenu(null); }}>
                  <Icon name="pencil" />{t("edit")}
                </button>
              )}
              {(isMaster(role) || isAdmin(role) ||
                hasPermission(permissionsByRole, role._id, "companies", "edit")) && (
                <button onClick={() => { openDesactivateActivateConfim(); setRowMenu(null); }}>
                  <Icon name={company.active ? "ban" : "check"} />{company.active ? t("deactivate") : t("activate")}
                </button>
              )}
              {(isMaster(role) || isAdmin(role) ||
                hasPermission(permissionsByRole, role._id, "companies", "delete")) && (
                <button className="company-item__row-menu-item--danger" onClick={() => { openDeleteConfirm(); setRowMenu(null); }}>
                  <Icon name="trash" />{t("delete")}
                </button>
              )}
            </div>,
            document.body
          )}
        </Table.Cell>
      </Table.Row>

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal} size={"small"}>
        <CompanyForm
          close={onOpenCloseModal}
          onReload={onReload}
          company={company}
        />
      </BasicModal>

      <ConfirmDialog
        open={showConfirm}
        title={confirmHeader}
        message={confirmMessage}
        onCancel={onOpenCloseConfirm}
        onConfirm={isDelete ? onDelete : onActivateDesactivate}
        confirmLabel="Aceptar"
        cancelLabel={t("cancel")}
        confirmDanger={isDelete}
      />

      

      {/* Modal de advertencia si no hay datos */}
      <Modal open={modalOpen} onClose={closeModal} size="tiny">
        <Modal.Header>
          <Icon name="warning sign" /> Advertencia
        </Modal.Header>
        <Modal.Content>
          <p>{contentModal}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={closeModal}>Cerrar</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}
